import { ToEntity } from 'core/common/mappers';
import { RecurringData } from '../entities';
import { RecurringStatusDto } from '../services/dto';

export class RecurringDataDtoMapper implements ToEntity<RecurringData, RecurringStatusDto> {
  toEntity(dto: RecurringStatusDto): RecurringData {
    return {
      orderId: dto.order_id,
      status: dto.status,
      createdAt: dto.created_at,
      verifyUrl: dto.verify_url,
      resignUrl: dto.resign_url,
      tokenId: dto.token_id,
    };
  }
}
